import { EventEmitter, inject, Injectable } from '@angular/core';
import { StorageStateService } from '@luzula/luzula-lib';
export enum Command {
	checkIn,
	discard,
	checkOut,
	checkOutEmpty,

	addPoint,
	discardPoint,
	deletePoint,
	deleteSelection,
	assignSelectionToProject,
	removeSelectionFromProject,
	savePoint,

	addAttachment,
	removeAttachment,

	goBack,
	goBackToPoint,

	importDirectories,
	importFiles,
	importWizard,
	batchEdit,
	batchEditHistory,
	gisExport,
	exportPdf,
	print,

	commentTools,
	commentSwitch,

	gpsHome,

	cleanUp,

	// App-eigene Kommandos ans ENDE (Werte >= 27), damit die mit
	// @luzula/luzula-lib GETEILTEN Kommandos (checkIn..cleanUp) exakt dieselben
	// Zahlenwerte behalten wie das Lib-Command-Enum
	// (projects/luzula-lib/src/lib/core/types/command.enum.ts). Beide Enums teilen
	// sich EINE NavbarService (NAVBAR_PROVIDER), die ueber den NUMERISCHEN enum-Wert
	// schluesselt — wuerden diese App-Only-Kommandos die Lib-Kommandos verschieben,
	// landet eine Lib-Subscription auf einem fremden App-Kommando (Bug 2026-06-21:
	// lib.removeAttachment(12) == bpweb.savePoint(12) -> beim Oeffnen des Karte-
	// Reiters erschien faelschlich der „Punkt Speichern"-Knopf). Absicherung:
	// navbar-command-conformance.spec.ts.
	freigebenSelection,
	zuruecknehmenSelection,
	/** Protokoll: Abschnitte aus einem anderen Punkt übernehmen (PLAN-punktdaten-uebernehmen.md). */
	punktdatenHolen,
}

@Injectable({
	providedIn: 'root'
})
export class NavbarService {
	title = '';
	componentTitle = '';
	
	events = new Map<Command,EventEmitter<any>>;
	private active_ = new Set<Command>;
	
	ls = inject(StorageStateService);

	constructor() {
		Object.keys(Command).filter((v) => !isNaN(Number(v))).forEach((value: string, index: number) => {
			this.events.set(Number(value), new EventEmitter<void>);
		});
	}

	clear() {
		this.active_.clear();
	}
	
	activate(c: Command) {
		this.active_.add(c);
	} 
	
	isActive(c: Command) {
		return this.active_.has(c);
	}
	
	subscribe<T>(c: Command, callback: (p: T) => void) {
		this.active_.add(c);
		const ev = this.events.get(c);
		// Immer neuen EventEmitter mit neuem Callback erstellen
		// damit Unterkomponenten (z.B. HL-Area) den Callback überschreiben können
		if (ev?.observed) ev.unsubscribe();
		const newEv = new EventEmitter<void>;
		this.events.set(c, newEv);
		newEv.subscribe(callback);
	}
	
	unsubscribe(c: Command) {
		this.active_.delete(c);
		const ev = this.events.get(c)!;
		if (ev.observed) ev.unsubscribe();
	}
	
	command(c: Command) {
		return this.events.get(c)!;
	}
	
	getTitle(): string {
		return this.title ? this.title : "Bohrpunkte";
	}
}
